/*
 * mshoulder-pdp.js
 * Mendable Shoulder PDP — variant system, dynamic pricing, gallery, AJAX cart,
 * live cart-count sync, accordions, smooth-scroll, qty selector.
 *
 * No global pollution. IIFE + window.__mshoulderInit guard.
 * All selectors are scoped to .mshoulder-scope and use data-mshoulder-* attrs.
 */
(function () {
  'use strict';
  if (window.__mshoulderInit) return;
  window.__mshoulderInit = true;

  // ----------------------------------------------------------------
  // 0. utils
  // ----------------------------------------------------------------
  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function formatMoney(cents, currency) {
    var v = (cents / 100);
    var s = v.toFixed(v % 1 === 0 ? 0 : 2);
    // simple US default; the section also exposes shop's money_format via Liquid for parity
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  // ----------------------------------------------------------------
  // 1. Find scope + product blob
  // ----------------------------------------------------------------
  var scope = $('.mshoulder-scope[data-mshoulder-product-scope]');
  if (!scope) { initChromeOnly(); return; }

  var productScript = $('script[type="application/json"][data-mshoulder-product]', scope);
  var product = null;
  try { product = productScript ? JSON.parse(productScript.textContent) : null; } catch (e) { product = null; }

  if (!product || !product.variants || !product.variants.length) { initChromeOnly(); return; }

  // ----------------------------------------------------------------
  // 2. Variant state
  // ----------------------------------------------------------------
  var state = {
    optionNames: product.option_names || [],   // ["Pack"] etc.
    selectedOptions: [],                       // ["1× Pack"]
    currentVariant: null
  };

  // initial selection: ?variant= in URL > first available > first
  var initialVariant = null;
  try {
    var qsVariant = new URLSearchParams(window.location.search).get('variant');
    if (qsVariant) {
      var idNum = parseInt(qsVariant, 10);
      initialVariant = product.variants.find(function (v) { return parseInt(v.id, 10) === idNum; }) || null;
    }
  } catch (e) {}
  if (!initialVariant) {
    initialVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
  }
  state.currentVariant = initialVariant;
  state.selectedOptions = initialVariant.options.slice();

  // ----------------------------------------------------------------
  // 3. Render: price, savings, CTA label, sold-out, gallery
  // ----------------------------------------------------------------
  var els = {
    priceMain     : $('[data-mshoulder-price-main]', scope),
    priceWas      : $('[data-mshoulder-price-was]', scope),
    saveBadge     : $('[data-mshoulder-save-badge]', scope),
    sysLabel      : $('[data-mshoulder-pack-label]', scope),
    cartBtn       : $('[data-mshoulder-add-to-cart]', scope),
    qtyInput      : $('[data-mshoulder-qty-input]', scope),
    galleryMain   : $('[data-mshoulder-gallery-main]', scope),
    galleryThumbs : $('[data-mshoulder-gallery-thumbs]', scope),
    variantIdInput: $('[data-mshoulder-variant-id]', scope)
  };

  function computeSavings(variant) {
    var price = variant.price;
    var compare = variant.compare_at_price || 0;
    var diffCents = compare > price ? compare - price : 0;
    var pct = compare > price ? Math.round((diffCents / compare) * 100) : 0;
    return { price: price, compare: compare, diff: diffCents, pct: pct };
  }

  function renderPriceFromVariant(variant) {
    if (!variant) return;
    var s = computeSavings(variant);
    if (els.priceMain) els.priceMain.textContent = formatMoney(s.price);
    if (els.priceWas) {
      if (s.compare > s.price) {
        els.priceWas.innerHTML = 'Reg. <s>' + formatMoney(s.compare) + '</s> · Today: <strong>' + formatMoney(s.price) + ' total</strong>';
        els.priceWas.hidden = false;
      } else {
        els.priceWas.hidden = true;
      }
    }
    if (els.saveBadge) {
      if (s.diff > 0) {
        els.saveBadge.textContent = 'SAVE ' + formatMoney(s.diff) + ' · ' + s.pct + '% OFF';
        els.saveBadge.hidden = false;
      } else {
        els.saveBadge.hidden = true;
      }
    }
    if (els.cartBtn) {
      if (variant.available) {
        els.cartBtn.removeAttribute('disabled');
        els.cartBtn.textContent = 'Add to Cart — ' + formatMoney(s.price) + ' →';
      } else {
        els.cartBtn.setAttribute('disabled', 'disabled');
        els.cartBtn.textContent = 'Sold out';
      }
    }
    if (els.sysLabel) {
      els.sysLabel.innerHTML = 'Showing: <strong>' + (variant.title || state.selectedOptions.join(' / ')) + '</strong> — change quantity below.';
    }
    if (els.variantIdInput) els.variantIdInput.value = variant.id;
    // Mirror price to the sticky bottom CTA (if present)
    var stickyPrice = document.querySelector('[data-mshoulder-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
  }

  // sync the pack-option cards' active state to selectedOptions
  function renderPackCards() {
    $$('[data-mshoulder-option]', scope).forEach(function (el) {
      var optName = el.getAttribute('data-mshoulder-option');
      var optValue = el.getAttribute('data-mshoulder-value');
      var idx = state.optionNames.indexOf(optName);
      if (idx === -1) return;
      var on = state.selectedOptions[idx] === optValue;
      el.classList.toggle('mshoulder-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // ----------------------------------------------------------------
  // 4. Gallery
  // ----------------------------------------------------------------
  function setMainImage(url, alt) {
    if (!els.galleryMain) return;
    var img = els.galleryMain.querySelector('img');
    if (!img) {
      // build it if missing
      els.galleryMain.innerHTML = '';
      img = document.createElement('img');
      img.style.width = '100%'; img.style.height = '100%'; img.style.objectFit = 'cover';
      els.galleryMain.appendChild(img);
    }
    img.src = url; img.alt = alt || '';
  }

  function syncActiveThumb(url) {
    if (!els.galleryThumbs) return;
    var thumbs = $$('.mshoulder-gallery-thumb', els.galleryThumbs);
    var match = null;
    thumbs.forEach(function (t) {
      var src = t.getAttribute('data-mshoulder-thumb-src');
      var on = src === url;
      t.classList.toggle('mshoulder-active', on);
      if (on) match = t;
    });
    if (match) {
      // horizontal scroll ONLY — never scrollIntoView
      var c = els.galleryThumbs;
      var cRect = c.getBoundingClientRect();
      var tRect = match.getBoundingClientRect();
      var dx = (tRect.left + tRect.right) / 2 - (cRect.left + cRect.right) / 2;
      try {
        c.scrollTo({ left: c.scrollLeft + dx, behavior: 'smooth' });
      } catch (e) {
        c.scrollLeft = c.scrollLeft + dx;
      }
    }
  }

  function swapImageForVariant(variant) {
    if (!variant || !variant.featured_image_url) return;
    setMainImage(variant.featured_image_url, product.title);
    syncActiveThumb(variant.featured_image_url);
  }








  // ----------------------------------------------------------------
  // 4.8 Gallery spec v2 — drag-to-scroll + momentum (mouse & touch)
  //     applies to both the main image track and the thumbs strip.
  // ----------------------------------------------------------------
  (function () {
    var DRAG_MULT = 1;
    var DECAY     = 0.92;
    var V_CAP     = 40;
    var MIN_V     = 0.4;

    function dragify(el, opts) {
      if (!el || el.__dragified) return;
      el.__dragified = true;
      opts = opts || {};

      var down = false;
      var startX = 0;
      var startScroll = 0;
      var lastX = 0;
      var lastT = 0;
      var velocity = 0;
      var raf = 0;

      function settle() { if (opts.onSettle) opts.onSettle(); }

      function inertia() {
        velocity *= DECAY;
        if (Math.abs(velocity) < MIN_V) {
          velocity = 0;
          raf = 0;
          settle();
          return;
        }
        el.scrollLeft -= velocity;
        raf = requestAnimationFrame(inertia);
      }

      function start(x) {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        down = true;
        startX = lastX = x;
        startScroll = el.scrollLeft;
        velocity = 0;
        lastT = performance.now();
        el.classList.add('is-dragging');
      }
      function move(x) {
        if (!down) return;
        var dx = (x - startX) * DRAG_MULT;
        el.scrollLeft = startScroll - dx;
        var now = performance.now();
        var dt  = Math.max(1, now - lastT);
        var instant = (x - lastX) / dt * 16; // px per frame approx
        velocity = Math.max(-V_CAP, Math.min(V_CAP, instant));
        lastX = x;
        lastT = now;
      }
      function end() {
        if (!down) return;
        down = false;
        el.classList.remove('is-dragging');
        if (Math.abs(velocity) > MIN_V) raf = requestAnimationFrame(inertia);
        else settle();
      }

      // mouse
      el.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        start(e.clientX);
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) { if (down) move(e.clientX); });
      window.addEventListener('mouseup',   function ()  { end(); });
      window.addEventListener('mouseleave',function ()  { end(); });

      // touch is intentionally NOT bound here — native iOS/Android scroll
      // + the track's scroll-snap-type: x proximity handles swipes cleanly.
      // Binding both caused double-scroll jitter and broke snap landing.
    }

    function nearestIndex(track, slides) {
      var midX = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (sl, i) {
        var c = sl.offsetLeft + sl.clientWidth / 2;
        var d = Math.abs(c - midX);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    var track  = $('[data-mshoulder-gallery-track]', scope);
    var thumbs = $('[data-mshoulder-gallery-thumbs]', scope);
    var slides = track ? $$('[data-mshoulder-gallery-slide]', track) : [];
    var thumbEls = thumbs ? $$('.mshoulder-gallery-thumb', thumbs) : [];

    // Apply drag-to-scroll to both
    dragify(track, {
      onSettle: function () {
        if (!slides.length) return;
        var idx = nearestIndex(track, slides);
        var target = slides[idx];
        if (target) {
          // Smoothly snap to the nearest slide center
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      }
    });
    dragify(thumbs);

    // Click a thumb → scroll the track to that slide
    thumbEls.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var target = slides[i];
        if (target && track) {
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    // Track scroll → update active thumb
    if (track && slides.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var idx = nearestIndex(track, slides);
          thumbEls.forEach(function (t, i) {
            t.classList.toggle('mshoulder-active', i === idx);
            t.classList.toggle('active', i === idx);
          });
          // pull the active thumb into view horizontally
          var at = thumbEls[idx];
          if (at && thumbs) {
            var cRect = thumbs.getBoundingClientRect();
            var tRect = at.getBoundingClientRect();
            var dx = (tRect.left + tRect.right) / 2 - (cRect.left + cRect.right) / 2;
            try { thumbs.scrollTo({ left: thumbs.scrollLeft + dx, behavior: 'smooth' }); }
            catch (e) { thumbs.scrollLeft += dx; }
          }
        });
      });
    }
    // gallery-spec-v2
  })();


  // ----------------------------------------------------------------
  // 4.9 Desktop gallery arrows — prev/next click cycle through slides
  //     [desktop-gallery-arrows]
  // ----------------------------------------------------------------
  (function () {
    var trk    = $('[data-mshoulder-gallery-track]', scope);
    if (!trk) return;
    var prev   = $('[data-mshoulder-gallery-prev]', scope);
    var next   = $('[data-mshoulder-gallery-next]', scope);
    var slides = $$('[data-mshoulder-gallery-slide]', trk);
    if (!slides.length) return;

    function currentIndex() {
      var midX = trk.scrollLeft + trk.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (sl, i) {
        var c = sl.offsetLeft + sl.clientWidth / 2;
        var d = Math.abs(c - midX);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function go(delta) {
      var idx = currentIndex();
      var next = idx + delta;
      if (next < 0) next = 0;
      if (next > slides.length - 1) next = slides.length - 1;
      var target = slides[next];
      if (target) trk.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      updateDisabled(next);
    }
    function updateDisabled(idx) {
      if (typeof idx !== 'number') idx = currentIndex();
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(+1); });

    // Keep disabled state in sync as user drags / swipes
    var rafTick = false;
    trk.addEventListener('scroll', function () {
      if (rafTick) return;
      rafTick = true;
      requestAnimationFrame(function () { rafTick = false; updateDisabled(); });
    });
    updateDisabled();
  })();

  // ----------------------------------------------------------------
  // 5. Variant change
  // ----------------------------------------------------------------
  function pickVariant() {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === state.selectedOptions[i]; });
    });
  }

  function selectOption(name, value) {
    var idx = state.optionNames.indexOf(name);
    if (idx === -1) return;
    state.selectedOptions[idx] = value;
    var v = pickVariant();
    if (!v) return;
    state.currentVariant = v;
    renderPackCards();
    renderPriceFromVariant(v);
    swapImageForVariant(v);
  }

  // delegated option clicks
  on(scope, 'click', function (e) {
    var el = e.target.closest('[data-mshoulder-option]');
    if (!el) return;
    e.preventDefault();
    selectOption(el.getAttribute('data-mshoulder-option'), el.getAttribute('data-mshoulder-value'));
  });

  // thumb clicks
  on(scope, 'click', function (e) {
    var t = e.target.closest('.mshoulder-gallery-thumb[data-mshoulder-thumb-src]');
    if (!t) return;
    var url = t.getAttribute('data-mshoulder-thumb-src');
    setMainImage(url, t.getAttribute('data-mshoulder-thumb-alt') || product.title);
    syncActiveThumb(url);
  });

  // ----------------------------------------------------------------
  // 6. Quantity
  // ----------------------------------------------------------------
  on(scope, 'click', function (e) {
    var b = e.target.closest('[data-mshoulder-qty-step]');
    if (!b || !els.qtyInput) return;
    var step = parseInt(b.getAttribute('data-mshoulder-qty-step'), 10) || 0;
    var v = (parseInt(els.qtyInput.value, 10) || 1) + step;
    if (v < 1) v = 1; if (v > 10) v = 10;
    els.qtyInput.value = v;
  });

  // ----------------------------------------------------------------
  // 7. Add to cart
  // ----------------------------------------------------------------
  function openCartDrawer() {
    // dispatch the common cart events; theme drawers listen to one of these
    var evts = ['cart:open', 'cart:added', 'drawer:open', 'cart-update'];
    evts.forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      window.dispatchEvent(new CustomEvent(n));
    });
    if (window.publish) { try { window.publish('cart-update', {}); } catch (e) {} }
    // fallback: click the theme cart trigger
    var trig = document.querySelector('cart-drawer-button, a[href$="/cart"], [data-cart-trigger], .header__icon--cart, button[aria-controls*="cart"]');
    if (trig && typeof trig.click === 'function') trig.click();
  }

  on(scope, 'submit', function (e) {
    var f = e.target.closest('form[data-mshoulder-form]');
    if (!f) return;
    e.preventDefault();
    if (!state.currentVariant || !state.currentVariant.available) return;

    var qty = parseInt(els.qtyInput && els.qtyInput.value, 10) || 1;
    var btn = els.cartBtn;
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding…'; }

    var body = {
      items: [{ id: state.currentVariant.id, quantity: qty }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || 'Add to cart failed');
        // never redirect — open the drawer
        refreshCartCount();
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[mshoulder]', err);
        alert('Sorry, that variant could not be added.');
      })
      .then(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = orig; }
        renderPriceFromVariant(state.currentVariant);
      });
  });


  // ----------------------------------------------------------------
  // 7.5 PayPal express button → add current variant + qty, then go to /checkout
  //     [paypal-direct-checkout]
  // ----------------------------------------------------------------
  on(scope, 'click', function (e) {
    var btn = e.target.closest('[data-mshoulder-paypal]');
    if (!btn) return;
    e.preventDefault();
    if (!state.currentVariant || !state.currentVariant.available) return;

    var qty = parseInt(els.qtyInput && els.qtyInput.value, 10) || 1;
    btn.textContent = 'Loading…';
    btn.style.pointerEvents = 'none';

    // Fire-and-forget the cart add. sendBeacon bypasses the fetch/XHR
    // pipeline so theme cart-drawer hooks never see it; the browser
    // delivers the request even while/after we navigate to /checkout.
    var fd = new FormData();
    fd.append('id', state.currentVariant.id);
    fd.append('quantity', qty);

    var sent = false;
    if (navigator.sendBeacon) {
      try { sent = navigator.sendBeacon('/cart/add', fd); } catch (_) { sent = false; }
    }
    if (!sent) {
      // Fallback: fetch with keepalive so it survives navigation
      try {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: state.currentVariant.id, quantity: qty }] }),
          keepalive: true
        });
      } catch (_) {}
    }
    window.location.href = '/checkout';
  });

  // ----------------------------------------------------------------
  // 8. Live header cart-count sync
  // ----------------------------------------------------------------
  function paintCount(n) {
    var els = $$('[data-mshoulder-cart-count]');
    els.forEach(function (e) { e.textContent = String(n || 0); });
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; })
      .catch(function () {});
  }
  // 1. Initial sync
  refreshCartCount();
  // 2. Hook fetch
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function () { setTimeout(refreshCartCount, 50); });
    }
    return p;
  };
  // 3. Hook XHR
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.addEventListener('load', function () {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        setTimeout(refreshCartCount, 50);
      }
    });
    return _open.apply(this, arguments);
  };
  // 4. Listen to events from theme + 3rd-party carts (UPCART, Bold, Rebuy, etc.)
  var cartEvents = ['cart:updated','cart:added','cart-update','upcart:updated','bold-cart:updated','rebuy:cart.update','rebuy:cart:update'];
  cartEvents.forEach(function (n) {
    document.addEventListener(n, refreshCartCount);
    window.addEventListener(n, refreshCartCount);
  });
  // 5. Visibility change
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCartCount(); });
  // 6. Periodic poll while tab visible
  setInterval(function () { if (!document.hidden) refreshCartCount(); }, 30000);

  // ----------------------------------------------------------------
  // 9. Accordion (FAQ)
  // ----------------------------------------------------------------
  function initAccordions(root) {
    $$('[data-mshoulder-faq-item]', root).forEach(function (item) {
      var q = item.querySelector('[data-mshoulder-faq-question]');
      if (!q || q.__bound) return;
      q.__bound = true;
      on(q, 'click', function () {
        item.classList.toggle('mshoulder-open');
        var ex = item.classList.contains('mshoulder-open');
        q.setAttribute('aria-expanded', ex ? 'true' : 'false');
      });
    });
  }
  initAccordions(document);

  // ----------------------------------------------------------------
  // 10. Smooth anchor scroll (extra-defensive: theme may already handle it)
  // ----------------------------------------------------------------
  $$('a[href^="#"]').forEach(function (a) {
    on(a, 'click', function (e) {
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var t = document.querySelector(href);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 16;
      try {
        window.scrollTo({ top: y, behavior: 'smooth' });
      } catch (e2) {
        window.scrollTo(0, y);
      }
    });
  });


  // ----------------------------------------------------------------
  // 11. Sticky bottom ATC bar visibility + click handler
  //     [sticky-cta-init]
  // ----------------------------------------------------------------
  (function () {
    var bar = document.querySelector('[data-mshoulder-sticky-cta]');
    if (!bar) return;
    var btn = bar.querySelector('[data-mshoulder-sticky-cta-btn]');
    var hero = scope; // .mshoulder-scope[data-mshoulder-product-scope]
    var anchor = document.querySelector('[data-mshoulder-sticky-anchor]') ||
                 document.querySelector('[data-mshoulder-add-to-cart]');

    // Show the bar when the hero has scrolled above the viewport
    if (hero && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -80% 0px' });
      obs.observe(hero);
    }

    // Click behavior depends on data-sticky-action:
    //   'add'    → add current variant to cart and open the drawer directly
    //   'scroll' → scroll back to the pack selector (default)
    var stickyAction = bar.getAttribute('data-sticky-action') || 'scroll';
    if (btn && stickyAction === 'add') {
      btn.addEventListener('click', function () {
        if (!state.currentVariant || !state.currentVariant.available) return;
        var qty = parseInt(els.qtyInput && els.qtyInput.value, 10) || 1;
        var orig = btn.textContent;
        btn.setAttribute('disabled', 'disabled');
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: state.currentVariant.id, quantity: qty }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body && res.body.description || 'Add to cart failed');
            refreshCartCount();
            openCartDrawer();
          })
          .catch(function (err) {
            console.error('[mshoulder sticky]', err);
            alert('Sorry, that variant could not be added.');
          })
          .then(function () {
            btn.removeAttribute('disabled');
            btn.textContent = orig;
          });
      });
    } else if (btn && anchor) {
      btn.addEventListener('click', function () {
        var headroom = 120; // px of breathing room above the anchor
        var y = anchor.getBoundingClientRect().top + window.scrollY - headroom;
        if (y < 0) y = 0;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); }
        catch (e) { window.scrollTo(0, y); }
      });
    }
  })();

  // initial paint
  renderPackCards();
  renderPriceFromVariant(state.currentVariant);

  // ----------------------------------------------------------------
  // helper: pages without the PDP scope still get cart count + accordions
  // ----------------------------------------------------------------
  function initChromeOnly() {
    refreshCartCount();
    initAccordions(document);
  }
})();
